import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a63eaa86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-15" }, " Detalhes da Transferência ", -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_4 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"right"} }, "Transferência Estornada", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-badge-status-dot ss-span-status estornada" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estornar", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_marcador_movimento_financeiro = _resolveComponent("selecionar-marcador-movimento-financeiro")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": _ctx.telaBase.apresentarEmpresas?'scroll-modal ss-modal-financeiro':'ss-modal-financeiro'
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.props.excluido)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.state.exibirEstorno && !_ctx.props.excluido)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmarEstorno()))
          }, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, { titulo: "DADOS DA TRANSFERÊNCIA" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Data",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_data, {
                        horaMinutoSegundo: true,
                        dataSelecionada: _ctx.state.transferencia.dataMovimento,
                        "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.transferencia.dataMovimento) = $event)),
                        disabled: true
                      }, null, 8, ["dataSelecionada"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_form_item, {
                    label: "N.Identificação",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.identificadorMovimento) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.state.transferencia.movimentoFinanceiroSaida.identificadorMovimento]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "Valor",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_campo_numerico, {
                        monetario: true,
                        quantidadeCasasDecimais: 2,
                        valor: _ctx.state.transferencia.movimentoFinanceiroSaida.valor,
                        "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.valor) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.descricao) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.state.transferencia.movimentoFinanceiroSaida.descricao]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_a_form_item, {
                    label: "Conciliado",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_sim_nao, {
                        radioButton: true,
                        valor: _ctx.state.transferencia.movimentoFinanceiroSaida.conciliado,
                        "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.conciliado) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_a_form_item, {
                    label: "Marcadores",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_marcador_movimento_financeiro, {
                        marcadoresSelecionados: _ctx.state.marcadores,
                        "onUpdate:marcadoresSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                        empresas: [_ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa],
                        disabled: true
                      }, null, 8, ["marcadoresSelecionados", "empresas"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "MOVIMENTO DE SAÍDA" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: _ctx.telaBase.carregando
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa) = $event)),
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.telaBase.apresentarEmpresas]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_selecionar_conta, {
                        codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroSaida.codigoConta,
                        "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.codigoConta) = $event)),
                        empresas: [_ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa],
                        disabled: true
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroSaida.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.codigoTipoDocumentoFinanceiro) = $event)),
                            empresas: [_ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa],
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_a_form_item, {
                        label: "Categoria",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroSaida.codigoPlanoContaCategoria,
                            "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroSaida.codigoPlanoContaCategoria) = $event)),
                            empresas: [_ctx.state.transferencia.movimentoFinanceiroSaida.codigoEmpresa],
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "MOVIMENTO DE ENTRADA" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: _ctx.telaBase.carregando
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroEntrada.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoEmpresa) = $event)),
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.telaBase.apresentarEmpresas]
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_selecionar_conta, {
                        codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroEntrada.codigoConta,
                        "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoConta) = $event)),
                        empresas: [_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoEmpresa],
                        disabled: true
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroEntrada.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoTipoDocumentoFinanceiro) = $event)),
                            empresas: [_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoEmpresa],
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_a_form_item, {
                        label: "Categoria",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_categoria_plano_conta, {
                            codigoSelecionado: _ctx.state.transferencia.movimentoFinanceiroEntrada.codigoPlanoContaCategoria,
                            "onUpdate:codigoSelecionado": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoPlanoContaCategoria) = $event)),
                            empresas: [_ctx.state.transferencia.movimentoFinanceiroEntrada.codigoEmpresa],
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresas"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}